const layout1Settings = {
  leftSidebar: {
    open: false,
    secondaryNavOpen: false,
  },
  searchBox: {
    open: false
  }
};

export default layout1Settings;
